import { render } from "./ValidationErrors.vue?vue&type=template&id=6c01dab1"
import script from "./ValidationErrors.vue?vue&type=script&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/webcrm-develop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__